import { readonly, ref } from 'vue'

export type ThemeId = 'light' | 'colorful' | 'dark'

export const themeOptions: ReadonlyArray<{
  id: ThemeId
  name: string
  description: string
}> = [
  { id: 'light', name: '清朗白', description: '清晰、克制的专业阅读体验' },
  { id: 'colorful', name: '水晶蓝', description: '通透、明亮的蓝紫玻璃体验' },
  { id: 'dark', name: '沉浸黑', description: '低亮度、强对比的夜间界面' },
]

const storageKey = 'rio-portal-theme'
const validThemes = new Set<ThemeId>(themeOptions.map((option) => option.id))
const activeTheme = ref<ThemeId>('colorful')

function isThemeId(value: string | null): value is ThemeId {
  return value !== null && validThemes.has(value as ThemeId)
}

function applyTheme(theme: ThemeId) {
  activeTheme.value = theme
  document.documentElement.dataset.theme = theme
  document.documentElement.style.colorScheme = theme === 'dark' ? 'dark' : 'light'
}

export function initializeTheme() {
  const savedTheme = window.localStorage.getItem(storageKey)
  applyTheme(isThemeId(savedTheme) ? savedTheme : 'colorful')
}

export function setTheme(theme: ThemeId) {
  applyTheme(theme)
  window.localStorage.setItem(storageKey, theme)
}

export function useTheme() {
  return {
    activeTheme: readonly(activeTheme),
    setTheme,
    themeOptions,
  }
}
